export default "__VITE_ASSET__DYk3hXJH__"